import { Progress, Space } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';

// duration is in days
// frequency is in ms
const getUpdateFrequency = (duration) => {
  let freq = 500;

  if (duration <= 1) {
    freq = 200;
  } else if (duration <= 7) {
    freq = 300;
  } else if (duration <= 30) {
    freq = 500;
  } else if (duration <= 90) {
    freq = 1000;
  } else if (duration <= 180) {
    freq = 2000;
  } else if (duration > 180) {
    freq = 3000;
  }

  return freq;
};

// start fast and slow down towards the end
// <25% => 5 to 7 inc
// 25 - 50% => 3 to 4 inc
// 50 - 75% => 2 to 3 inc
// 75 - 98% => 0 to 1 inc
const getInc = (min = 1, max = 5) => Math.floor(Math.random() * (max - min) + min);

function useProgress({ duration }) {
  const [percent, setPercent] = useState(0);
  const updateFreq = useMemo(() => getUpdateFrequency(duration), [duration]);

  const increase = () => {
    setPercent((prevPct) => {
      let inc = 0;
      if (prevPct < 25) {
        inc = getInc(5, 8);
      }
      if (prevPct < 50) {
        inc = getInc(3, 5);
      } else if (prevPct < 75) {
        inc = getInc(2, 4);
      } else if (prevPct < 98) {
        inc = getInc(0, 2);
      }
      const newPercent = prevPct + inc;
      return newPercent;
    });
  };

  useEffect(() => {
    const interval = setInterval(() => {
      increase();
    }, updateFreq);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return { percent };
}

function ProgressBar({ duration }) {
  const { percent } = useProgress({ duration });
  return (
    <Space>
      <Progress type="circle" percent={percent} size={50} strokeWidth={10} />
    </Space>
  );
}

export default ProgressBar;
